/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { Departement, Individu } from '@/types';

import { validationSituationFamiliale, validationInformationsNaissance , validationRecensement } from '..';

const validationStep1 = (
  individu: Partial<Individu>,
) => {
  return ({
    ...validationInformationsNaissance(
        individu,
    ),
    ...validationSituationFamiliale(individu),
    ...validationRecensement(
        individu,
        individu?.exemptionActive,
      ),
  });
};

export default validationStep1;
